<template>
  <div id="price-city-radar" style="height: 340px"></div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {
      option: {
        title: { show: false },
        legend: {
          data: [
            { name: '2023', color: '#f2f023' },
            { name: '2024', color: '#fc669b' },
          ],
          textStyle: { fill: '#cfcfcf' },
          right: 0,
          top: 20,
        },
        grid: { top: 0, left: 0, right: 0 },
        radar: {
          // polygon: true,
          radius: '80%',
          indicator: [
            { name: '上海', max: 35 },
            { name: '深圳', max: 35 },
            { name: '北京', max: 35 },
            { name: '杭州', max: 35 },
            { name: '苏州', max: 35 },
            { name: '广州', max: 35 },
            { name: '合肥', max: 35 },
          ],
          axisLabel: {
            style: { fill: '#cfcfcf' },
          },
          axisLine: {
            style: { stroke: '#666' },
          },
          splitLine: {
            style: { stroke: '#3f3f3f' },
          },
        },
        series: [
          {
            name: '2023',
            type: 'radar',
            data: [32.5, 31.1, 28.9, 25.8, 23.9, 23.4, 22.8],
            radarStyle: {
              lineWidth: 1,
              fill: 'rgba(0xfc,0x66,0x9b,.5)',
              stroke: '#fc669b',
            },
            label: {
              style: { fill: '#fc669b' },
            },
            animationCurve: 'easeOutBounce',
          },
          {
            name: '2024',
            type: 'radar',
            data: [24.7, 25.4, 23.2, 23.6, 21.7, 19.4, 16.9],
            radarStyle: {
              lineWidth: 1,
              fill: 'rgba(0xf2,0xf0,0x23,.5)',
              stroke: '#f2f023',
            },
            label: {
              style: { fill: '#f2f023' },
            },
            animationCurve: 'easeOutBounce',
          },
        ],
      },
      // {
      //   title: { show: false },
      //   grid: { top: 0, left: 0, right: 0 },
      //   legend: {
      //     data: ['特级果', '一级果'],
      //     textStyle: {
      //       fill: '#9cd9fc',
      //     },
      //     top: 15,
      //     right: 0,
      //   },
      //       style: {
      //         fill: '#9cd9fc',
      //       },
      //       gradient: {
      //         color: ['#37a2da', '#67e0e3'],
      //       },
      //       gradient: {
      //         color: ['#daa237', '#e3e067'],
      //       },
    }
  },
  mounted() {
    const container = document.getElementById('price-city-radar')
    const myChart = new Charts(container)
    myChart.setOption(this.option)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/market-zone/price-city-radar.vue